export const FAST_TAG_CONNECT = "CONNECT";

export const FAST_TAG_EDIT = "EDIT";

export type FastTagOperation = typeof FAST_TAG_CONNECT | typeof FAST_TAG_EDIT;
